import React, { useRef, useEffect, CSSProperties } from 'react';
import { Form } from 'react-bootstrap';

const MemoryTextArea = ({
    value,
    id,
    className,
    onChange,
    onBlur,
    onKeyPress,
    rows,
    readOnly,
    placeholder,
    required,
    formSubmitted,
    style,
}: {
    value: string;
    id: string;
    className?: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onBlur: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
    onKeyPress?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
    rows: number;
    readOnly: boolean;
    placeholder?: string;
    required?: boolean;
    formSubmitted?: boolean;
    style?: CSSProperties;
}) => {
    const textAreaRef = useRef<HTMLTextAreaElement>(null);

    // useEffect(() => {
    //     if (textAreaRef?.current) {
    //         const textArea = textAreaRef.current;

    //         if (value.trim() === '') {
    //             textArea.style.height = 'auto';
    //             textArea.style.height = '56px';
    //         } else {
    //             textArea.style.height = 'auto';
    //             textArea.style.height = `${textArea.scrollHeight}px`;
    //         }
    //     }
    // }, [value]);
    useEffect(() => {
        if (textAreaRef?.current) {
            const textArea = textAreaRef.current;
            const minTextAreaHeight = 56;
            const maxTextAreaHeight = 324;

            textArea.style.height = `${minTextAreaHeight}px`;
            const scrollHeight = `${textArea.scrollHeight}px`;

            if (!value) {
                textArea.style.height = `${minTextAreaHeight}px`;
                textArea.style.overflowY = 'hidden';
            } else {
                const newHeight = Math.min(textArea.scrollHeight, maxTextAreaHeight);
                textArea.style.height = `${newHeight}px`;
                textArea.style.overflowY = 'auto';
                textArea.style.overflowY = newHeight === maxTextAreaHeight ? 'auto' : 'hidden';
            }
        }
    }, [textAreaRef, value]);
    return (
        <Form.Control
            as="textarea"
            ref={textAreaRef}
            id={id}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onKeyPress={onKeyPress}
            rows={rows}
            readOnly={readOnly}
            placeholder={placeholder}
            className={`p-3 ${
                formSubmitted && value.trim() === '' ? 'is-invalid' : ''
            } ${className}`}
            required={required}
            style={{ overflow: 'hidden', ...style }}
        />
    );
};

export default MemoryTextArea;
